export default class {
    constructor(timeout) {
        this.timeout = timeout;
        this.nextCallback = () => null;
		this.handler = null;
    }

    debounce(callback) {
    	if(this.handler) {
			clearTimeout(this.handler);
		}
        this.handler = setTimeout(callback, this.timeout);
    }

    prevent(callback) {
        if(!this.waitState) {
            this.waitState = true;
            callback();
            setTimeout(() => this.waitState = false, this.timeout);
        }
    }
}